export default __webpack_public_path__ + "static/media/school_clubs_tile.b5cb8dbc.jpg";